export default "__VITE_ASSET__dS9hvwpm__"